import { render, staticRenderFns } from "./CreateGlobalNote.vue?vue&type=template&id=4f988d6f&scoped=true&"
import script from "./CreateGlobalNote.vue?vue&type=script&lang=js&"
export * from "./CreateGlobalNote.vue?vue&type=script&lang=js&"
import style0 from "./CreateGlobalNote.vue?vue&type=style&index=0&id=4f988d6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f988d6f",
  null
  
)

export default component.exports